export const LOAD_SLIDER = 'Casino/HomePage/LOAD_SLIDER'
export const LOAD_SLIDER_SUCCESS = 'Casino/HomePage/LOAD_SLIDER_SUCCESS'
export const LOAD_SLIDER_ERROR = 'Casino/HomePage/LOAD_SLIDER_ERROR'

export const NEXT_SLIDE = 'Casino/HomePage/NEXT_SLIDE'
export const PREVIOUS_SLIDE = 'Casino/HomePage/PREVIOUS_SLIDE'
export const GO_TO_SLIDE = 'Casino/HomePage/GO_TO_SLIDE'

export const TRANSITION_END = 'Casino/HomePage/TRANSITION_END'

export const LOAD_COLLECT_HOME = 'Casino/HomePage/LOAD_COLLECT_HOME'
export const LOAD_COLLECT_HOME_SUCCESS = 'Casino/HomePage/LOAD_COLLECT_HOME_SUCCESS'
export const LOAD_COLLECT_HOME_ERROR = 'Casino/HomePage/LOAD_COLLECT_HOME_ERROR'

export const DURATION = 5000
